import { Link } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'components/ui/Tooltip';
import classNames from 'classnames';
const baseClassName = 'text-left block px-4 py-2 text-sm no-underline hover:no-underline group z-10';
const normalStateClassName = 'text-gray-700 hover:text-gray-900 hover:bg-gray-100';
const disabledTextClassName = 'cursor-not-allowed text-gray-500';
const DropdownItem = ({ children, disabled, href, onClick, className, target, dataTestId, disabledText, disabledTextPosition, isExternalLink, }) => {
    function handleClick(e) {
        if (!disabled && onClick) {
            onClick(e);
        }
    }
    if (disabled) {
        return ((React.createElement(Tooltip, { dataTestId: "Tooltip-f4c9f9ce", "data-testid": dataTestId, content: disabledText, position: disabledTextPosition },
            React.createElement("span", { "data-testid": "span-9bddf35b", className: classNames(baseClassName, disabledTextClassName) }, children))));
    }
    if (isExternalLink) {
        return (React.createElement("a", { href: href, target: target, onClick: handleClick, className: classNames(baseClassName, normalStateClassName, className), role: "menuitem", "data-testid": dataTestId }, children));
    }
    return (React.createElement(Link, { to: href, target: target, onClick: handleClick, className: classNames(baseClassName, normalStateClassName, className), role: "menuitem", "data-testid": dataTestId }, children));
};
const disabledTextPositions = {
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
};
DropdownItem.propTypes = {
    href: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.any,
    target: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    disabledText: PropTypes.string,
    disabledTextPosition: PropTypes.oneOf(Object.keys(disabledTextPositions)),
    isExternalLink: PropTypes.bool,
};
DropdownItem.defaultProps = {
    target: '_self',
    disabledText: 'disabled',
    isExternalLink: true,
};
export default DropdownItem;
